module.exports = __webpack_public_path__ + "static/media/fail.1c6e72bb.svg";